<template>
	<div>
		<myheader></myheader>
		<div class="all_main seachMain">
			<div class="searchArea">
				<div class="all_height22" style="position: absolute; left: 0;top:0;right: 2.5rem;">
					<van-search id="searchInput" v-model="keyword" shape="round" background="#0277FC"
						placeholder="请输入合同名称" @search="searchClick" clearable>
						<!-- 	<template #action>
							<div @click="searchClick" class="textcolorwhite" style="padding:0 .3rem;">搜索</div>
						</template> -->
					</van-search>
					<!-- <van-field v-model="value1" left-icon="search" placeholder="输入合同" /> -->
				</div>
				<div class="text14 all_line_height18 textcolorwhite"
					style="position: absolute;right: 0;top: .2rem;width: 2rem;" @click="searchClick()">搜索
				</div>
			</div>
			<div class="all_height20 backgroundC_white" style="position: relative;z-index: 8;">
				<van-dropdown-menu active-color="#0277FC" style="max-width: 85%; float: left;">
					<van-dropdown-item v-model="qyvalue" :options="qylist" @change="qyItemChange()" />
				</van-dropdown-menu>
				<div class="display_flex" style="position: absolute;right: .5rem;top: 0;"
					@click="showFilterTop=!showFilterTop">
					<img src="@/assets/images/u38.png" style="width:1rem;margin: .5rem 0;">
					<span class="text14 textcolor333" style="line-height: 2rem;margin-left: .1rem;">筛选</span>
				</div>
			</div>
			<div class="horizontal_line"></div>
			<div style="position: relative;">
				<div class="filterpop" :class="{pophidden:!showFilterTop,popshow:showFilterTop}">
					<div style="padding: 0 .5rem;">
						<!-- <div class="text14 textcolor333 margin_top_5">合同状态</div>
						<div class="horizontal_flex flex_space-around margin_top_2">
							<span class="text12 textcolor333" v-for="(item,index) in contractStatus"
								@click="selectStatusClick(index)"
								:style="{'background-color': (statusIndex==index)?'#cccccc':'#f2f2f2'}"
								:key="index">{{item}}</span>
						</div> -->
						<div class="text14 textcolor333 margin_top_5">发起时间</div>
						<div class="horizontal_flex flex_space-around margin_top_2">
							<span class="text12 textcolor333" v-for="(item,index) in contractTime"
								@click="selectTimeClick(index)"
								:style="{'background-color': (timeIndex==index)?'#cccccc':'#f2f2f2'}"
								:key="index">{{item}}</span>
						</div>
						<div class="horizontal_flex flex_space-around margin_top_8">
							<div class="time text12 textcolor333" @click="dateShow = true">
								{{beginTimeShow===''?'开始日期':beginTimeShow}}
							</div>
							<div class="time text12 textcolor333" @click="dateShow = true">
								{{endTimeShow===''?'结束日期':endTimeShow}}
							</div>
						</div>
					</div>
					<div class="horizontal_line" style="margin-top: 1rem;"></div>
					<div class="horizontal_flex flex_wrap" style="height: 2rem;">
						<div class="text14 textcolor333 all_height_line20 backgroundC_white bwhite_ative"
							style="width: 49.9%;text-align: center;" @click="resetSearchClick()">重置
						</div>
						<div class="vertical_line"></div>
						<div class="text14 textcolorwhite all_height_line20 backgroundC_main bmain_active"
							style="width: 49.9%;text-align: center;" @click="sumbitSearchClick()">确认</div>
					</div>
					<div class="horizontal_line"></div>
				</div>
				<div ref="contractList" class="all_list_content_nopadding"
					style="top:1px; min-height: 83vh;height: auto;">
					<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
						<van-list v-model="listloading" :finished="listfinished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div class="list" v-for="(item,index) in list" :key="index" @click="itemClick(item,index)">
								<div class="listitem">
									<div class="listitemtitle text14 textcolor333 font_weight_700">
										{{item.contractName}}
									</div>
									<div class="listitemcontent text12 textcolor999" style="margin-top: .5rem;">
										{{'合同编号： '+(Tool.isNoEmpty(item.contractCode)?item.contractCode:'-')}}
									</div>
									<div class="listitemcontent text12 textcolor999">
										{{'接收时间： '+(Tool.isNoEmpty(item.createdTime)?Tool.dateFormate(item.createdTime):'-')}}
									</div>
									<div class="listitemstatus text12 all_text_center" :class="{sign_status_ing:item.contractStatus===0,
									sign_status_ed:item.contractStatus===1,sign_status_can:item.contractStatus===2}">
										{{item.contractStatus===0?'待签约':(item.contractStatus===1?'已签约':'已取消')}}
									</div>
								</div>
								<div class="horizontal_line"></div>
							</div>
						</van-list>
						<van-empty style="margin-top: 15vh;" description="没有数据" v-show="list.length==0" />
					</van-pull-refresh>
				</div>
			</div>
		</div>
		<van-calendar v-model:show="dateShow" type="range" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm"
			color="#0277FC" />
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Search,
		DropdownMenu,
		DropdownItem,
		Calendar,
		Empty,
		PullRefresh,
		List,
	} from 'vant';
	// Vue.use(Search).use(DropdownMenu).use(DropdownItem).use(Calendar)
	// 	.use(Empty).use(PullRefresh).use(List);
	export default {
		name: 'contractsearch',
		components: {
			[Search.name]: Search,
			[DropdownMenu.name]: DropdownMenu,
			[DropdownItem.name]: DropdownItem,
			[Calendar.name]: Calendar,
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
			[List.name]: List,
		},
		data() {
			return {
				//合同类型
				contractType: '',
				//关键词
				keyword: '',
				//企业id
				qyvalue: null,
				//企业列表
				qylist: [],
				//条件弹窗显示
				showFilterTop: false,
				//状态列表
				contractStatus: [
					'全部',
					'待签署',
					'已完成',
					'已取消',
				],
				//时间田间列表
				contractTime: [
					'全部',
					'今天',
					'近一周',
					'近一月',
				],
				//状态选择index
				statusIndex: 0,
				//时间选择index
				timeIndex: 0,
				//时间范围
				dateRange: [],
				//时间弹窗显示
				dateShow: false,
				minDate: new Date(2018, 0, 1),
				maxDate: new Date(),
				//是否刷新
				refreshing: false,
				//下一页加载
				listloading: false,
				//下一页加载完成
				listfinished: false,
				//开始时间
				beginTime: '',
				//结束时间
				endTime: '',
				//开始时间
				beginTimeShow: '',
				//结束时间
				endTimeShow: '',
				//每页数量
				pageSize: 10,
				//第几页
				pageNum: 0,
				//合同列表
				list: [],
				//操作item
				selectItem: null,
				//操作item index
				selectIndex: -1,
			}
		},
		methods: {
			//列表滑动
			contractListScroll(event) {
				this.changeShowFilterTop()
				//console.log(event)
				this.scrollTop = this.$refs.contractList.scrollTop
			},
			//条件显示
			changeShowFilterTop() {
				if (this.showFilterTop) {
					this.showFilterTop = false
				}
			},
			//搜索
			searchClick() {
				//console.log('suosou')
				this.showFilterTop = false
				this.onReLoad()
			},
			//选择合同状态
			selectStatusClick(index) {
				this.statusIndex = index
			},
			//条件确定
			sumbitSearchClick() {
				this.showFilterTop = false
				this.onReLoad()
			},
			//重置条件
			resetSearchClick() {
				this.statusIndex = 0
				this.selectTimeClick(0)
				this.showFilterTop = false
				this.onReLoad()
			},
			//查看合同详情
			itemClick(item, index) {
				this.selectItem = item
				this.selectIndex = index
				this.$router.push({
					path: '/contractdetails',
					query: {
						contractId: item.contractId,
						corpId: item.corpId
					}
				})
			},
			//条件变化，重新加载
			onReLoad() {
				this.showFilterTop = false
				this.refreshing = true
				this.onRefresh()
			},
			// 下拉刷新
			onRefresh() {
				this.changeShowFilterTop()
				this.$store.dispatch(this.$LoadShow, true)
				this.listfinished = false;
				// 将 loading 设置为 true，表示处于加载状态
				this.listloading = true;
				this.pageNum = 0
				this.onLoad();
				this.getEnterpriseList()
			},
			// 上拉加载
			onLoad() {
				// 清空列表数据
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.pageNum++
				this.getContractList()
			},
			//获取合同列表
			getContractList() {
				let url = '/contract/api/queryPagedAllContracts'
				// switch (this.navActive) {
				// 	case 0:
				// 		url = '/contract/api/queryPagedActingContracts'
				// 		break;
				// 	case 1:
				// 		url = '/contract/api/queryPagedCompletedContracts'
				// 		break;
				// 	case 2:
				// 		url = '/contract/api/queryPagedCancelledContracts'
				// 		break;
				// }
				this.$post(url, JSON.stringify({
					contractName: this.keyword,
					corpId: this.qyvalue,
					beginDate: this.beginTime,
					endDate: this.endTime,
					pageParams: {
						desc: true,
						orderBy: "created_time",
						current: this.pageNum,
						size: this.pageSize,
					}
				})).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.listloading = false;
					if (res.success && res.data) {
						this.list = this.list.concat(res.data.records);
						// 加载状态结束
						this.listloading = false;
						//数据全部加载完成
						if (this.list.length >= res.data.total) {
							this.listfinished = true;
						}
					} else {
						this.$Toast(res.message || '网络异常！');
					}
				})
				/*this.$post('/contract/api/list', JSON.stringify({
					contractStatus: this.statusIndex,
					corpId: this.qyvalue,
					keyword: this.keyword,
					beginTime: this.beginTime,
					endTime: this.endTime,
					current: this.pageNum,
					size: this.pageSize,
				})).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.listloading = false;
					if (res.success && res.data) {
						this.list = this.list.concat(res.data.records);
						// 加载状态结束
						this.listloading = false;
						//数据全部加载完成
						if (this.list.length >= res.data.total) {
							this.listfinished = true;
						}
						//console.log(this.list)
					} else {
						this.$Toast(res.message || '网络异常！');
					}
				})*/
			},
			//选择条件类型
			selectTimeClick(index) {
				if (this.timeIndex != index) {
					let currData = new Date()
					//let tempData = new Date()
					switch (index) {
						case 0:
							this.beginTime = ''
							this.beginTimeShow = ''
							this.endTime = ''
							this.endTimeShow = ''
							break;
						case 1:
							this.endTime = this.Tool.getDataISOString(currData.toISOString())
							this.endTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							currData.setDate(currData.getDate() - 1)
							this.beginTime = this.Tool.getDataISOString(currData.toISOString())
							this.beginTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							break;
						case 2:
							this.endTime = this.Tool.getDataISOString(currData.toISOString())
							this.endTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							currData.setDate(currData.getDate() - 7)
							this.beginTime = this.Tool.getDataISOString(currData.toISOString())
							this.beginTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							break;
						case 3:
							this.endTime = this.Tool.getDataISOString(currData.toISOString())
							this.endTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							currData.setDate(currData.getDate() - 30)
							this.beginTime = this.Tool.getDataISOString(currData.toISOString())
							this.beginTimeShow= this.Tool.formate(currData, 'yyyy-MM-dd')
							break;
					}
					this.timeIndex = index
				}
			},
			//选择时间范围
			onConfirm(values) {
				var start = values[0]
				var end = values[1]
				this.dateShow = false
				this.beginTime = this.Tool.getDataISOString(start.toISOString())
				this.endTime = this.Tool.getDataISOString(end.toISOString())
				this.beginTimeShow = start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate()
				this.endTimeShow = end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate()
			},
			//企业下拉列表改变
			qyItemChange() {
				// this.selectTimeClick(0)
				// this.statusIndex = 0
				//console.log('改变了' + this.qyvalue)
				this.onReLoad()
			},
			//获取企业列表数据
			getEnterpriseList() {
				this.$get("/contract/api/getMyCorps").then((res) => {
					this.qylist = []
					this.qylist.push({
						value: null,
						text: '全部企业'
					})
					if (res.success && res.data) {
						for (let item of res.data) {
							this.qylist.push({
								value: item.corpId,
								text: item.corpName
							})
						}
						//console.log(this.qylist)
					} else {
						console.log(res)
						//this.$Toast('获取企业列表失败！')
					}
				});
			},
			//获取合同详情
			getContractDetails() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/contract/api/detail", JSON.stringify({
					contractId: this.selectItem.contractId,
					corpId: this.selectItem.corpId
				})).then((res) => {
					this.$store.commit('changeContractStatus', false)
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						if (res.data.contractStatus === 1 || res.data.contractStatus === 2) {
							this.list[this.selectIndex].contractStatus = res.data.contractStatus
							this.list[this.selectIndex].contractStatusText = res.data.contractStatusText
						}
					}
				});
			},
		},
		activated() {
			//console.log('cms-activated')
			if (this.scrollTop != 0) {
				this.$refs.contractList.scrollTop = this.scrollTop
			}
			if (this.$store.state.contractStatus && this.selectIndex != -1) {
				this.getContractDetails()
			}
		},
		deactivated() {
			//console.log('cms-deactivated')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			//console.log("el-beforeRouteLeave", to, from);
			if (to.meta.index > from.meta.index) {
				if (from.meta.keepAlive) {
					this.$store.commit('addKeepAlive', from.name);
				}
			} else {
				if (from.meta.keepAlive) {
					this.$store.commit('removeKeepAlive', from.name);
				}
			}
			//console.log(this.$store.state.keepAlive)
			next();
		},
		mounted() {
			// this.contractType = this.$route.query.type
			// switch (this.contractType) {
			// 	case '待签约':
			// 		this.statusIndex = 1
			// 		break;
			// 	case '完成签约':
			// 		this.statusIndex = 1
			// 		break;
			// 	case '取消签约':
			// 		this.statusIndex = 3
			// 		break;
			// }
			this.$refs.contractList.addEventListener('scroll', this.contractListScroll);
			this.getEnterpriseList()
			setTimeout(() => {
				document.getElementById('searchInput').focus()
				//this.$refs.searchInput.focus()
			}, 500)
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.searchArea {
		position: absolute;
		top: 1.8rem;
		height: 2.2rem;
		left: 2.3rem;
		right: 0;
		z-index: 10;

		::v-deep .van-search {
			padding: 0;
			margin-top: .25rem;
		}
	}

	.seachMain {
		.filterpop {
			position: absolute;
			z-index: 6;
			width: 100%;
			// height: 11.4rem;
			transition: top .3s linear 0s;
			background-color: white;

			span {
				width: 3rem;
				line-height: 1.4rem;
				text-align: center;
				border-radius: .8rem;
			}

			.time {
				width: 6rem;
				line-height: 1.4rem;
				text-align: center;
				border-radius: 1rem;
				border: 1px solid #cccccc;

			}

		}

		.pophidden {
			top: -12.05rem;
		}

		.popshow {
			top: 0.005rem;
		}

		.list {
			// padding: .1rem 0;
			// padding-top: .5rem;
			// margin-top: .2rem;
			height: auto;

			.listitem {
				width: 100%;
				padding: .5rem;
				background-color: white;
				position: relative;

				.listitemtitle {
					width: 85%;
					font-weight: bold;
					line-height: 1.2rem;
				}

				.listitemcontent {
					margin-top: .4rem;
					line-height: .6rem;
				}

				.listitemstatus {
					position: absolute;
					top: .3rem;
					right: .5rem;
					width: 2.8rem;
					height: 1rem;
					line-height: 1rem;
					color: white;
					border-radius: 0.1rem;
				}

			}

			.listitem:active {
				background-color: #f6f6f6;
			}
		}

		::v-deep .van-dropdown-menu__bar {
			height: 2rem;
			box-shadow: none;
		}

		::v-deep .van-dropdown-menu__title {
			padding: 0 .5rem;
			line-height: 1.8rem;
		}

	}

	::v-deep .van-calendar__confirm {
		height: 2.2rem;
	}
</style>